import parsePhoneNumber from 'libphonenumber-js'

export const parsedPhoneNumber = phone => {
  let parsedPhone = parsePhoneNumber(phone, 'US')
  return parsedPhone ? parsedPhone.nationalNumber : ''
}
